<template>
    <div class="item-card item-card--property-theme">
        <!-- Image -->
        <div class="image" style="background-size: cover;background-repeat: no-repeat;" :style="{ 'background-image': 'url(/images/demo/' + (Math.floor(Math.random() * 8) + 1) + '.jpg)' }"></div>

        <!-- Name -->
        <span class="name">
            {{ item.name }}
        </span>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
